export default class Cookies {
    constructor() {
        this.cookieName = 'co2-calculator-primx';
        this.init();
    }
    init() {
        const self = this;
        this.button = document.querySelector('#cookies-confirm');
        this.cookieModal = document.querySelector('.cookies-confirm');
        if (!this.button)
            return;
        this.button.addEventListener('click', () => {
            this.setCookie(self.cookieName, 'true', 30);
            // reload page
            this.cookieModal.style.display = 'none';
        });
    }
    setCookie(cname, cvalue, exdays) {
        const d = new Date();
        d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
        let expires = "expires=" + d.toUTCString();
        document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
    }
}
